/**
 * Config: Canvas
 * -----------------------------------------------------------------------------
 * Custom config for Canvas, allows limited access to compiler config.
 *
 */
const vueHelperEmptyImports = {};

['block-class', 'class', 'format-date', 'format-image-url', 'format-money', 'string', 'timing', 'variable']
  .forEach((helper) => {
    vueHelperEmptyImports[helper] = {
      variable: `HELPER_${helper.replaceAll('-', '_')}`.toUpperCase(),
      value: false,
    }
  })

module.exports = {

  /**
   * Theme scripts async config.
   * - Provide name of script as found in dist/snippets/theme-scripts.liquid.
   * - Included scripts will be loaded with `async` attribute.
   * - Other scripts default to `defer` attribute.
   * - Ignored when in hot mode.
   */
  asyncScripts: [
    'bundle.global-components.min.js',
    'bundle.vendors.min.js',
    'layout.password.min.js',
    'layout.theme.min.js',
  ],

  /**
   * Sets branch naming convention.
   * - `camel` supports feature/CANVAS-101-branchName.
   * - `kebab` supports feature/CANVAS-101-branch-name.
   * - `both` supports both of the above.
   */
  branchNaming: 'kebab',

  /**
   * Set default browser to open `watch` command with.
   * - Do not use Chrome when store has a storefront password.
   * - Accepts `firefox`, `chrome`, `edge`, or `safari`.
   */
  browser: 'firefox',

  /**
   * CSS optimiser config.
   * - `classes` - Set classes to optimise (remove if not used), classes created
   *   in utility stylesheets are automatically set to be optimised.
   * - `enable` - Run CSS optimiser.
   * - `enableDevMode` - Run CSS optimiser in development mode (watch).
   * - `keep` - Do not remove these classes even if not used.
   * - `stylesheets` - Set stylesheets to optimise (remove unused classes from).
   */
  cssOptimiser: {
    classes: ['grid'],
    enable: true,
    enableDevMode: false,
    keep: [
      'xs1-3',
      'xs4-6',
      'l2-3',
      'l5-11',
    ],
    stylesheets: [
      'critical-checkout.min.css',
      'critical-gift_card.min.css',
      'critical-password.min.css',
      'critical-theme.min.css',
      'layout.theme.min.css',
    ],
  },

  /**
   * Array of custom elements not to be compiled by Vue.
   */
  customElements: [],

  /**
   * Set to true if using the custom content tool.
   */
  customContentTool: false,

  /**
   * Set production conditions for replacing import files with empty versions.
   * - Each key refers to the file name of a script JS file that has a
   *   *.empty.js copy.
   * - If property is a boolean then it doesn't react to variables.
   * - If the property is an object then the value of the variable is checked,
   *   and if it returns true then the file is replaced with the empty version.
   * - E.g. process.env[variable] === value
   */
  emptyImports: {
    'app-handler': false,
    bugsnag: {
      variable: 'BUGSNAG_API_KEY',
      value: false,
    },
    commands: {
      variable: 'NODE_ENV',
      value: 'production',
    },
    ...vueHelperEmptyImports,
  },

  /**
   * Enable .min extension on compiled JS and CSS files.
   */
  minExtension: true,

  /**
   * Set breakpoints that are considered mobile.
   */
  mobileBreakpoints: ['xs', 's', 'm'],

  /**
   * Open bundle analyser report in browser when one is built.
   * - Reports are built when in production mode (yarn build), or in development
   *   mode when --build-report flag is used (yarn build --dev --build-report).
   */
  openReport: false,

  /**
   * Asset files to prefetch.
   * - Ignored when in hot mode.
   * - `files` - Provide name of asset to prefetch, do not include filetype,
   *   e.g. 'component.main-product' or 'template.customers'.
   * - `css` - Prefetch asset CSS files.
   * - `js` - Prefetch asset JS files.
   */
  prefetchAssets: {
    files: [
      'component.cart-drawer',
      'component.main-product',
      'template.customers',
    ],
    css: true,
    js: true,
  },
}
